import { render, staticRenderFns } from "./PLMAI.vue?vue&type=template&id=042e4735&scoped=true"
import script from "./PLMAI.vue?vue&type=script&lang=js"
export * from "./PLMAI.vue?vue&type=script&lang=js"
import style0 from "./PLMAI.vue?vue&type=style&index=0&id=042e4735&prod&lang=scss&scoped=true"
import style1 from "./PLMAI.vue?vue&type=style&index=1&id=042e4735&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e4735",
  null
  
)

export default component.exports